// extracted by mini-css-extract-plugin
export default {"header":"styles_header__gQmpn","breadcrumbsWrapper":"styles_breadcrumbsWrapper__iaP5Q","logoLink":"styles_logoLink__UOgaJ","sider":"styles_sider__uokdB"};